
/**
 * the vuex is need to be careful when you don't understand
 */
import date from '../src/assets/common/date';

const state = {
  CURRENT_DATE: date(Date.now(), '%F'),
  pkList: {},
  // 确认盘库的数组
  confirm_PK_list: [],
  // 盘库ID
  PK_ID: 0,
  // 盘库CODE
  PK_CODE: '',
  // ---------库存
  SHOW_KC: 0,
  SAVE_PANENAME: '',
  // 进销存
  DEPOSIT_DATA_CONDITION: {},
  // ----------------------------------------结算管理自录客户结算
  NEW_ORDER_SEARCH_DATA_CONDITION: {},
  // --------------------------------------供应商结算
  READY_SEARCH_DATA_CONDITION: {},
  // -----------------------------------团餐客户结算
  ORDER_LIST_SEARCH_CONDITION: {},
  // --------------------------------自录客户结算列表
  ORDER_LIST_CONDITION: {},
  // --------------------------------团餐结算列表
  TC_ORDER_LIST_CONDITION: {},
  // --------------------------------供应商结算列表
  GYS_ORDER_LIST_CONDITION: {},

  // -----------------销售订单
  ENTRY_SEARCH_DATA_CONDITION: {},
  XMD_CONFIRM_SEARCH_DATA_CONDITION: {},
  CONFIRM_SEARCH_DATA_CONDITION: {},
  HISTORY_SEARCH_DATA_CONDITION: {},
  ALL_SEARCH_DATA_CONDITION: {},
  SERACH_SELL_ORDER_DATA_CONDITION: {},

  // ----------------------采购订单
  NEWORDER_SEARCH_DATA_CONDITION: {},
  NEWORDER_HISTORY_DATA_CONDITION: {},

  // ---------------------表报--出库单
  HISTORY_OUT_DATA_CONDITION: {},
  HISTORY_IN_DATA_CONDITION: {},
  SAVE_OTHER_PANENAME: {},
  // ------------------------销售订单--------新增产品
  NEW_ADD_ORDER_CONDITION: {},
  // ---------------------------------供应商管理---新增产品
  GYS_ADD_ORDER_CONDITION: {},

  CMD_INFO_CONDITION: {},

  // 销售订单----->客户
  TAB_SALES_DATE: '',
  // 销售订单 ----》打印标签
  S_PRINT_ALL: {},
  // 报表 -------》每日剩余库存表
  DAILYINVENTORY_ALL: {},
  // 报表 -------》盘库盈亏表
  PROFITLOSSTABLE_ALL: {},
  // 报表 -------》销售退库单
  RETURNWAREHOUSE_ALL: {},
  // 报表 -------》销售退货单
  RETURNGOODS_ALL: {},
  // 报表 -------》采购退货单
  RETURNPRODUCT_ALL: {},
  // 报表 -------》销售报表
  SALESSTATEMENTS_ALL: {},
  // 报表 -------》毛利报表
  GROSSPROFIT_ALL: {},
  // 报表 -------》采购报表
  PURCHASE_ALL: {},
  // 报表 -------》进销存报表
  TOTALDEPOSITPURCHASE_ALL: {},
  // 报表 -------》客户毛利表
  TCGROSSPROFIT_ALL: {},
  // 报表 -------》销售退货单
  SELLORDERRETURN_ALL: {},
  // 报表 -------》采购价格变化趋势
  PRICECHANGECHART_ALL: {},
  // 报表 -------》商品销售排行
  PRODUCTRANKLIST_ALL: {},
  // 报表 -------》总仓单品毛利表
  SINGLERANGE_ALL: {},
  // ----------------------------------采买单筛选条件
  PURCHASE_SEARCH: {},
  // ------------------------------------2021.4.7新增分菜单管理
  SORT_SEARCH: {},
  // ------------------------------------领料单
  SAVE_PICKING_DOC: {},
  // ------------------------------------生产领料单
  SAVE_PRO_PICKING_DOC: {},
  // 生产入库
  SAVE_PRO_WAREHOUSING: {},
  // 生产入库单
  SAVE_PRO_RECEIPT: {},
  // -------------------------------------客户列表
  SAVE_CUSTOMER_LIST: {},
  // -------------------------------------供应商管理
  SUPPLIER_LIST: {},
  // --------------------------------------生产配置管理
  PRODUCTION_LIST: {},
  // -------------------------------------出库汇总单
  TOTAL_OUT_DOC_LIST: {},
  // 仓库管理->盘库筛选条件记录
  INVENTORY_SEARCH: {},
  // 人员管理
  PERSON_MANAGE_DATA_CONDITION: {},
  // 库位
  POSITION_CONDITION: {},
  // 一类
  FIRST_CATEGORY_DATA_CONDITION: {},
  // 二类
  SECOND_CATEGORY_DATA_CONDITION: {},
  // 在用SKU管理
  SKU_USED_DATA_CONDITION: {},
  // 待确认订单
  CONFIRM_DATA_CONDITION: {},
  CONFIRM_DATA_CONDITION_S: {},
  // WMS-临时仓
  WMS_TEMPORARYSTOCK_CONDITION: {},
  // WMS-库存预警
  WMS_STOCKWARNING_CONDITION: {},
  // 拣货单界面
  PICKINGLIST_CONDITION: {},
  // 价格管理-客户定价复核
  CUSTOMER_PRICING_REVIEW_CONDITION: {},
  // 销售订单管理-销售价复核
  SALES_PRICE_REVIEW_CONDITION: {},
  // 产品管理-产品税率-供应商税率设置
  SUPPLIERTAX_DATA_CONDITION: {},
  // 报表-送货差异表
  DELIVERY_DISCREPANCY_DATA_CONDITION: {},
  // 分拣配送-分拣组管理
  SORTING_GROUP_MANAGEMENT_CONDITION: {},
  // 财务中心-发票列表
  INVOICE_LIST_DATA_CONDITION: {},
  // 分拣配送-周转筐管理
  TURNOVER_MANAGE_DATA_CONDITION: {},
  // 价格管理-销售价格查询
  SALES_PRICE_INQUIRY_CONDITION: {},
  // 价格管理-采购价格查询
  PURCHASE_PRICE_INQUIRY_CONDITION: {},
  // 第三方配送订单-转换订单
  SUPPLIER_SEND_ORDER_CONDITION: {},
  // 第三方配送订单-历史订单
  DSHISTORY_ORDER_LIST_CONDITION: {},
  // 第三方配送订单-待送订单
  DS_ORDER_LIST_CONDITION: {},
  // 第三方配送订单-待确认订单
  DS_ORDER_CONFIRM_LIST_CONDITION: {},
  // 报表-业务部毛利表
  BUSINESS_GROSS_PROFIT_TABLE: {},
  // 购物车中新增按钮状态记录,检验是否从新增按钮进入购物车,false为不显示模态框
  isAddBtnToProduct: true,
  // 报表-仓库收发明细表
  WAREHOUSE_TRANSCEIVER_CONDITION: {},
  // 报表-采购部差价表
  PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION: {},
  // 销售订单管理-订单调价申请记录
  PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION: {},
  // 财务中心-客户结算-供应商客户
  SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION: {},
  // 销售订单管理-单外订单
  LOW_PRICE_ORDER_LIST: {},
  // 报表-项目销售日汇总表
  PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION: {},
  // 仓库管理-出库验收差异
  出库验收差异筛选条件: {},
  // 报表-订单产品毛利表
  订单产品毛利表筛选记忆: {},
  // 财务中心 供应商快捷结算
  供应商快捷结算筛选记忆: {},

  // 预约处理-未读列表
  UNREAD_INFORMATION_LIST: [],
  // 预约下载定时器ID
  APPOINTMENT_INTERVAL_ID: 0,
  ITEM_SALES_SCHEDULE: {},
  DS_ORDER_INQUIRY_DATA_CONDITION: {},
  DELIVERY_TASK_PROGRESS: {},
  stock_enter_detail: {},
  DS_UNPRICE_ORDER_DETAIL_CONDITION: {},
};

export default state;




//////////////////
// WEBPACK FOOTER
// ./store/state.js
// module id = null
// module chunks = 